const fail =
{
    text : "Erreur"
};

export default fail ;